// extracted by mini-css-extract-plugin
export default {"disabled":"Item_disabled__klE4J"};